import Field from "@/components/form/Field.tsx";
import FieldObject from "@/components/form/FieldObject.tsx";
import {MinimalTiptapEditor} from "@/components/minimal-tiptap";
import {Bot, LoaderCircle} from "lucide-react";
import {Textarea} from "@/components/ui/textarea.tsx";
import {Button} from "@/components/ui/button.tsx";
import React, {useContext, useState} from "react";
import {FormContext} from "@/components/form/Form.tsx";
import {Company} from "@/types/Company";
import axios from "axios";
import {Dialog, DialogContent, DialogTitle, DialogFooter} from "@/components/ui/dialog.tsx";

export default function SummaryEditor({company}: { company?: Company }) {
    const formctx = useContext(FormContext);

    function runAi() {
        setAiDialogOpen(false);
        setAiGenRunning(true);
        const summary = formctx.getValue("meetingSummary");
        const prompt = summary["ai_summary"];
        const intro = summary["intro"];

        formctx.setValue("meetingSummary", {
            intro,
            topics: "",
            subject_richtext: "",
        });

        axios.post(`${import.meta.env.VITE_SUMMARY_AI_URL}/generate`, {
            notes: prompt,
            companyData: company,
        }).then((res) => {
            const response = res.data;
            formctx.setValue("meetingSummary", {
                intro,
                topics: response["topics"],
                subject_richtext: response["subject_richtext"]
            });
        }).catch((error) => {
            console.error("Error generating summary:", error);
        }).finally(() => {
            setAiGenRunning(false);
        })
    }

    const [aiDialogOpen, setAiDialogOpen] = useState(false);
    const [aiGenRunning, setAiGenRunning] = useState(false);


    function AiGenButton() {
        return <Button variant={"ai"} onClick={() => setAiDialogOpen(true)}>
            {aiGenRunning ? <LoaderCircle className={"animate-spin"}/> : <> <Bot/>AI power</>
            }
        </Button>
    }

    return (
        <React.Fragment key={aiGenRunning ? 0 : 1}>
            <FieldObject name={"meetingSummary"}>
                <div>
                    <div className={"text-sm font-bold"}>Bevezetés</div>
                    <Field name={"intro"}>{(field) => <MinimalTiptapEditor
                        value={field.value}
                        onChange={field.onChange}
                        className="w-full"
                        editorContentClassName="p-5"
                        output="html"
                        placeholder="Ide írhatja a részleteket..."
                        autofocus={false}
                        editable={true}
                        editorClassName="focus:outline-hidden"
                    />
                    }
                    </Field>
                    <Dialog open={aiDialogOpen} onOpenChange={setAiDialogOpen}>
                        <DialogContent
                            className={"w-[80vw] h-[80vh] max-w-[100vw_!important] flex flex-col border-2 border-aiblue ring-2 ring-aiblue/50"}>
                            <DialogTitle className={"text-center w-full text-aiblue text-4xl font-black"}>Témák és
                                összefoglaló a találkozóról</DialogTitle>
                            <div className={"grow flex flex-col gap-4"}>
                                <Field name={'ai_summary'}>
                                    {
                                        (field) =>
                                            <Textarea className={"bg-white grow"} value={field.value}
                                                      onBlur={field.onBlur}
                                                      onChange={(e) => field.onChange(e.target.value)}></Textarea>
                                    }
                                </Field>
                            </div>
                            <DialogFooter><Button onClick={runAi} variant={"ai"}
                                                  className={"mt-2"}><Bot/>Generálás</Button></DialogFooter>
                        </DialogContent>
                    </Dialog>
                    <div className={"text-sm font-bold mt-3"}>Témák</div>
                    <Field name={'topics'}>
                        {
                            (field) =>
                                <MinimalTiptapEditor
                                    value={field.value}
                                    onChange={field.onChange}
                                    className="w-full"
                                    editorContentClassName="p-5"
                                    output="html"
                                    placeholder="Ide írhatja a részleteket..."
                                    autofocus={false}
                                    editable={true}
                                    editorClassName="focus:outline-hidden"
                                    toolbar={[<AiGenButton/>]}
                                    disabled={aiGenRunning}
                                />
                        }
                    </Field>

                    <div className={"text-sm font-bold mt-3"}>Összefoglaló a találkozóról</div>
                    <Field name={'subject_richtext'}>
                        {
                            (field) =>
                                <MinimalTiptapEditor
                                    value={field.value}
                                    onChange={field.onChange}
                                    className="w-full"
                                    editorContentClassName="p-5"
                                    output="html"
                                    placeholder="Ide írhatja a részleteket..."
                                    autofocus={false}
                                    editable={true}
                                    editorClassName="focus:outline-hidden"
                                    toolbar={[<AiGenButton/>]}
                                    disabled={aiGenRunning}
                                />
                        }
                    </Field>
                </div>
            </FieldObject>
        </React.Fragment>
    );
}